<template>
<div
  class="pearlie-sue"
  :class="{
    'body-two': bodyTwo,
    'railroad-body': railroadBody,
    'left-arm-point': leftArmPoint,
    'right-arm-point': rightArmPoint,
    'thumbs-up': thumbsUp,
    'eyes-half': eyesState === 'half',
    'eyes-closed': eyesState === 'closed',
    'mouth-open': mouthState === 'open',
    'mouth-open-teeth': mouthState === 'open-teeth',
    'mouth-teeth': mouthState === 'teeth',
    'mouth-o': mouthState === 'o'
  }"
>
  <div class="pearlie-sue__eyebrows"></div>
  <div class="pearlie-sue__eyes-open"></div>
  <div class="pearlie-sue__eyes-half"></div>
  <div class="pearlie-sue__eyes-closed"></div>
  <div class="pearlie-sue__mouth-closed"></div>
  <div class="pearlie-sue__mouth-open"></div>
  <div class="pearlie-sue__mouth-open-teeth"></div>
  <div class="pearlie-sue__mouth-teeth"></div>
  <div class="pearlie-sue__mouth-o"></div>
  <div class="pearlie-sue__left-arm-point"></div>
  <div class="pearlie-sue__right-arm-point"></div>
  <div class="pearlie-sue__thumbs-up"></div>
</div>
</template>

<script>
export default {
  name: 'pearlieSue',
  props: {
    bodyTwo: Boolean,
    railroadBody: Boolean,
    speakDuration: Array,
    leftArmPoint: Boolean,
    rightArmPoint: Boolean,
    thumbsUp: Boolean
  },
  data () {
    return {
      eyesState: '',
      eyesTimeCounter: 0,
      eyesInterval: null,
      eyesIntervalPeriod: 100,
      mouthState: '',
      mouthTimeCounter: 0,
      mouthInterval: null,
      mouthIntervalPeriod: 200
    }
  },
  mounted () {
    // Eyes
    clearInterval(this.eyesInterval)
    this.eyesInterval = setInterval(() => {
      if (this.eyesTimeCounter === (this.eyesIntervalPeriod * 50)) {
        this.eyesState = 'half'
        this.eyesTimeCounter += this.eyesIntervalPeriod
      } else if (this.eyesTimeCounter === (this.eyesIntervalPeriod * 51)) {
        this.eyesState = 'closed'
        this.eyesTimeCounter = 0
      } else {
        this.eyesState = ''
        this.eyesTimeCounter += this.eyesIntervalPeriod
      }
    }, this.eyesIntervalPeriod)
  },
  methods: {
    speak () {
      this.mouthState = ''
      this.mouthTimeCounter = 0
      let speakIndex = 0
      clearInterval(this.mouthInterval)
      this.mouthInterval = setInterval (() => {
        if ((speakIndex+1) <= this.speakDuration.length){
          if (this.mouthTimeCounter >= this.speakDuration[speakIndex+1]) {
            speakIndex++
          }
        } else {
          if (this.mouthTimeCounter >= this.speakDuration[speakIndex]) {
            this.mouthTimeCounter = 0
            clearInterval(this.mouthInterval)
          }
        }
        if (speakIndex % 2 === 0 && this.mouthTimeCounter >= this.speakDuration[speakIndex]){
          if (this.mouthTimeCounter <=50){
            this.mouthState = 'teeth'
          } else if (this.mouthTimeCounter % (this.mouthIntervalPeriod * 5) === 0) {
            this.mouthState = 'open-teeth'
          } else if (this.mouthTimeCounter % (this.mouthIntervalPeriod * 4) === 0) {
            this.mouthState = 'teeth'
          } else if (this.mouthTimeCounter % (this.mouthIntervalPeriod * 3) === 0) {
            this.mouthState = ''
          } else if (this.mouthTimeCounter % (this.mouthIntervalPeriod * 2) === 0) {
            this.mouthState = 'open'
          } else if (this.mouthTimeCounter % this.mouthIntervalPeriod === 0) {
            this.mouthState = 'mouth-o'
          }
        } else {
          this.mouthState = ''
        }
        this.mouthTimeCounter += this.mouthIntervalPeriod
        
      }, this.mouthIntervalPeriod)
    }
  },
  beforeDestroy () {
    clearInterval(this.eyesInterval)
    clearInterval(this.mouthInterval)
  }
}
</script>

<style lang="scss">
@keyframes ps-eyebrows {
  0% {
    transform: translate3d(0,0%,0);
  }
  20% {
    transform: translate3d(0,0%,0);
  }
  30% {
    transform: translate3d(0,-10%,0);
  }
  40% {
    transform: translate3d(0,0%,0);
  }
  60% {
    transform: translate3d(0,0%,0);
  }
  70% {
    transform: translate3d(0,-10%,0);
  }
  80% {
    transform: translate3d(0,0%,0);
  }
  100% {
    transform: translate3d(0,0%,0);
  }
}
@keyframes ps-hush {
  0% {
    transform: scaleX(-1) rotate3d(0,0,1,-24deg);
    transform-origin: left center;
  }
  40% {
    transform: scaleX(-1) rotate3d(0,0,.5,-40deg);
    transform-origin: left center;
  }
  60% {
    transform: scaleX(-1) rotate3d(0,0,.5,-40deg);
    transform-origin: left center;
  }
  100% {
    transform: scaleX(-1) rotate3d(0,0,.5,-24deg);
    transform-origin: left center;
  }
}
.pearlie-sue {
  position: relative;
  width: fluid(205px);
  height: fluid(270px);
  background-repeat: no-repeat;
  background-position: center center;
  background-size: contain;
  background-image: url('~@/assets/img/pearlie-sue-body-half.png');
  transform-origin: 0% 0%;
  &__left-arm-point {
    display: none;
    position: absolute;
    top: fluid(173px);
    left: fluid(196px);
    width: fluid(136px);
    height: fluid(65px);
    background-repeat: no-repeat;
    background-position: center center;
    background-size: contain;
    background-image: url('~@/assets/img/pearlie-sue-arm-point.svg');
    transform: scaleX(-1) rotate3d(0,0,1,-24deg);
    transform-origin: left center;
  }
  &__right-arm-point {
    display: none;
    position: absolute;
    bottom: fluid(19px);
    left: fluid(5px);
    width: fluid(142px);
    height: fluid(70px);
    background-repeat: no-repeat;
    background-position: center center;
    background-size: contain;
    background-image: url('~@/assets/img/pearlie-sue-arm-point.svg');
  }
  &__thumbs-up {
    display: none;
    position: absolute;
    bottom: fluid(14px);
    left: 0;
    width: fluid(100px);
    height: fluid(50px);
    background-repeat: no-repeat;
    background-position: center center;
    background-size: contain;
    background-image: url('~@/assets/img/pearlie-sue-thumbs-up.png');
    transform: rotate3d(0,0,1,-54deg);
  }
  &__eyebrows {
    position: absolute;
    top: fluid(65px);
    left: fluid(77px);
    width: fluid(44px);
    height: fluid(20px);
    background-repeat: no-repeat;
    background-position: center top;
    background-size: contain;
    background-image: url('~@/assets/img/pearlie-sue-eyebrows.svg');
    animation: ps-eyebrows 8s linear infinite;
  }
  &__eyes-open {
    position: absolute;
    top: fluid(77px);
    left: fluid(80px);
    width: fluid(43px);
    height: fluid(18px);
    background-repeat: no-repeat;
    background-position: center top;
    background-size: contain;
    background-image: url('~@/assets/img/pearlie-sue-eyes-open.svg');
  }
  &__eyes-half {
    display: none;
    position: absolute;
    top: fluid(77px);
    left: fluid(79px);
    width: fluid(43px);
    height: fluid(18px);
    background-repeat: no-repeat;
    background-position: center top;
    background-size: contain;
    background-image: url('~@/assets/img/pearlie-sue-eyes-half.svg');
  }
  &__eyes-closed {
    display: none;
    position: absolute;
    top: fluid(77px);
    left: fluid(79px);
    width: fluid(43px);
    height: fluid(18px);
    background-repeat: no-repeat;
    background-position: center top;
    background-size: contain;
    background-image: url('~@/assets/img/pearlie-sue-eyes-closed.svg');
  }
  &__mouth-closed {
    position: absolute;
    top: fluid(104px);
    left: fluid(94px);
    width: fluid(28px);
    height: fluid(11px);
    background-repeat: no-repeat;
    background-position: left top;
    background-size: contain;
    background-image: url('~@/assets/img/pearlie-sue-mouth-closed.svg');
  }
  &__mouth-open {
    display: none;
    position: absolute;
    top: fluid(104px);
    left: fluid(94px);
    width: fluid(28px);
    height: fluid(12px);
    background-repeat: no-repeat;
    background-position: left top;
    background-size: contain;
    background-image: url('~@/assets/img/pearlie-sue-mouth-open.svg');
  }
  &__mouth-open-teeth {
    display: none;
    position: absolute;
    top: fluid(103px);
    left: fluid(94px);
    width: fluid(27px);
    height: fluid(12px);
    background-repeat: no-repeat;
    background-position: left top;
    background-size: contain;
    background-image: url('~@/assets/img/pearlie-sue-mouth-open-teeth.svg');
  }
  &__mouth-teeth {
    display: none;
    position: absolute;
    top: fluid(104px);
    left: fluid(96px);
    width: fluid(27px);
    height: fluid(12px);
    background-repeat: no-repeat;
    background-position: left top;
    background-size: contain;
    background-image: url('~@/assets/img/pearlie-sue-mouth-teeth.svg');
  }
  &__mouth-o {
    display: none;
    position: absolute;
    top: fluid(104px);
    left: fluid(96px);
    width: fluid(28px);
    height: fluid(13px);
    background-repeat: no-repeat;
    background-position: left top;
    background-size: contain;
    background-image: url('~@/assets/img/pearlie-sue-mouth-o.svg');
  }
  &.left-arm-point {
    .pearlie-sue {
      &__left-arm-point {
        display: block;
      }
    }
  }
  &.right-arm-point {
    .pearlie-sue {
      &__right-arm-point {
        display: block;
      }
    }
  }
  &.thumbs-up {
    .pearlie-sue {
      &__thumbs-up {
        display: block;
      }
    }
  }
  &.eyes-half {
    .pearlie-sue {
      &__eyes-open {
        display: none;
      }
      &__eyes-half {
        display: block;
      }
    }
  }
  &.eyes-closed {
    .pearlie-sue {
      &__eyes-open {
        display: none;
      }
      &__eyes-closed {
        display: block;
      }
    }
  }
  &.mouth-open {
    .pearlie-sue {
      &__mouth-closed {
        display: none;
      }
      &__mouth-open {
        display: block;
      }
    }
  }
  &.mouth-open-teeth {
    .pearlie-sue {
      &__mouth-closed {
        display: none;
      }
      &__mouth-open-teeth {
        display: block;
      }
    }
  }
  &.mouth-teeth {
    .pearlie-sue {
      &__mouth-closed {
        display: none;
      }
      &__mouth-teeth {
        display: block;
      }
    }
  }
  &.mouth-o {
    .pearlie-sue {
      &__mouth-closed {
        display: none;
      }
      &__mouth-o {
        display: block;
      }
    }
  }
  &.body-two {
    background-image: url('~@/assets/img/pearlie-sue-body-half-2.png');
    .pearlie-sue {
      &__thumbs-up {
        bottom: fluid(29px);
        left: fluid(6px);
        width: fluid(120px);
        height: fluid(70px);
      }
      &__eyebrows {
        top: fluid(63px);
        left: fluid(83px);
        width: fluid(44px);
        height: fluid(20px);
      }
      &__eyes-open {
        top: fluid(76px);
        left: fluid(86px);
        width: fluid(43px);
        height: fluid(18px);
      }
      &__eyes-half {
        top: fluid(77px);
        left: fluid(87px);
        width: fluid(43px);
        height: fluid(18px);
      }
      &__eyes-closed {
        top: fluid(77px);
        left: fluid(87px);
        width: fluid(43px);
        height: fluid(18px);
      }
      &__mouth-closed {
        top: fluid(103px);
        left: fluid(99px);
        width: fluid(28px);
        height: fluid(11px);
      }
      &__mouth-open {
        top: fluid(103px);
        left: fluid(99px);
        width: fluid(28px);
        height: fluid(12px);
      }
      &__mouth-open-teeth {
        top: fluid(102px);
        left: fluid(99px);
        width: fluid(27px);
        height: fluid(12px);
      }
      &__mouth-teeth {
        top: fluid(103px);
        left: fluid(101px);
        width: fluid(27px);
        height: fluid(12px);
      }
      &__mouth-o {
        top: fluid(103px);
        left: fluid(101px);
        width: fluid(28px);
        height: fluid(13px);
      }
    }
  }
  &.railroad-body {
    background-image: url('~@/assets/img/pearlie-sue-body-railroad.png');
    .pearlie-sue {
      &__eyebrows {
        top: fluid(57px);
        left: fluid(81px);
        width: fluid(44px);
        height: fluid(20px);
      }
      &__eyes-open {
        top: fluid(70px);
        left: fluid(84px);
        width: fluid(43px);
        height: fluid(18px);
      }
      &__eyes-half {
        top: fluid(71px);
        left: fluid(85px);
        width: fluid(43px);
        height: fluid(18px);
      }
      &__eyes-closed {
        top: fluid(71px);
        left: fluid(85px);
        width: fluid(43px);
        height: fluid(18px);
      }
      &__mouth-closed {
        top: fluid(97px);
        left: fluid(99px);
        width: fluid(28px);
        height: fluid(11px);
      }
      &__mouth-open {
        top: fluid(97px);
        left: fluid(99px);
        width: fluid(28px);
        height: fluid(12px);
      }
      &__mouth-open-teeth {
        top: fluid(96px);
        left: fluid(99px);
        width: fluid(27px);
        height: fluid(12px);
      }
      &__mouth-teeth {
        top: fluid(97px);
        left: fluid(101px);
        width: fluid(27px);
        height: fluid(12px);
      }
      &__mouth-o {
        top: fluid(97px);
        left: fluid(101px);
        width: fluid(28px);
        height: fluid(13px);
      }
    }
  }
}
.hush-arm {
  .pearlie-sue {
    &__left-arm-point {
      animation: ps-hush 3s linear infinite;
    }
  }
}
</style>